import React from "react";
import { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Grid } from "antd";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import LeadsTable from "../components/Leads/LeadsTable";
import { connect } from "react-redux";
import { getAllLeads } from "../store/action/business/LeadAction";
import { getAllAdminLeads } from "../store/action/admin/LeadAdminAction";

const MyLeadsBusiness = (props) => {
  const { Title } = Typography;
  const { useBreakpoint } = Grid;
  const [leads, setLeads] = useState([]);
  const [value, setValue] = React.useState("one"); // Track the selected tab
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleChange = (event, newValue) => {
    setValue(newValue); // Update the selected tab
  };

  useEffect(() => {
    // if (props.user && props.user.role) {
    //   if (props.user.role === "admin") {
    //     props.getAllAdminLeads_();
    //   } else {
    //     props.getAllLeads_();
    //   }
    // }
    const role = localStorage.getItem("role");
    if (role === "admin") {
      props.getAllAdminLeads_();
    } else {
      props.getAllLeads_();
    }
  }, []);

  useEffect(() => {
    if (props.user && props.user.role) {
      if (props.user.role === "admin") {
        setLeads(props.allLeadsAdmin);
      } else {
        setLeads(props.allLeads);
      }
    }
  }, [props.allLeadsAdmin, props.allLeads]);

  return (
    <div style={{ padding: isMobile ? 10 : 20 }}>
      <Title level={isMobile ? 4 : 3}>My Leads</Title>
      <Row gutter={20} style={{ marginTop: isMobile ? 10 : 20 }}>
        <Col xs={24}>
          <LeadsTable
            leads={leads}
            mini={false}
            expand={true}
            scroll={{ x: isMobile ? 900 : true }}
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user?.response,
  allLeadsAdmin: state.allLeadsAdmin?.response?.leads || [],
  allLeads: state.allLeads?.response?.leads || [],
});

const mapDispatchToProps = (dispatch) => ({
  getAllLeads_: () => {
    dispatch(getAllLeads());
  },
  getAllAdminLeads_: () => {
    dispatch(getAllAdminLeads());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MyLeadsBusiness);
